export default __webpack_public_path__ + "static/media/178.f76f08f0.jpg";